import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import AuthContext from "../contexts/AuthProvider";
import Boats from "../components/Boats";
import { Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Home = () => {
  const { setAuth } = useContext(AuthContext);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const logout = async () => {
    // if used in more components, this should be in context
    // axios to /logout endpoint
    setAuth({});
    navigate("/login");
  };
  return (
    <Container className="my-3">
      <h1 className="text-center">Home</h1>
      <Boats />
      <br />
      <div className="custom-button secondary" onClick={logout}>
        <FontAwesomeIcon
          size="sm"
          icon="arrow-right-from-bracket"
          className="me-2"
        />
        {t("logout")}
      </div>
    </Container>
  );
};

export default Home;
